import React from 'react'

import { FinanceCreditCard, FinanceMoney, FinanceVallet, FinanceGold, FinanceCurrency, FinanceChart } from '@enuygun/icons'
import { down } from 'styled-breakpoints'
import styled from 'styled-components'

type IconOptionsProps = {
  $financeGuide?: boolean
  $currencyCalculation?: boolean
  $goldPrices?: boolean
  $isTablet?: boolean
}

const getIconBackground = ({ $financeGuide, $currencyCalculation, $goldPrices }: IconOptionsProps) => {
  if ($financeGuide) return '#fcf2dd'
  if ($currencyCalculation) return '#e5f6ed'
  if ($goldPrices) return '#FFEC89'
  return 'transparent'
}

const getIconColor = ({ $financeGuide, $currencyCalculation, $goldPrices }: IconOptionsProps) => {
  if ($financeGuide) return '#EAA61A'
  if ($currencyCalculation) return '#13882B'
  if ($goldPrices) return '#FFBF03'
  return 'transparent'
}

const IconOptions = styled.div<IconOptionsProps>`
  background: ${getIconBackground};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${getIconColor};
  width: ${(props) => (props.$isTablet ? '32px' : '60px')};
  height: ${(props) => (props.$isTablet ? '32px' : '60px')};
  padding: ${(props) => {
    if (props.$isTablet) {
      return props.$financeGuide ? '7px' : '4px'
    }
    return props.$financeGuide ? '15px' : '8px'
  }};

  ${down('sm')} {
    width: 32px;
    height: 32px;
    padding: ${(props) => (props.$financeGuide ? '7px' : '4px')};
  }

  svg path {
    height: 500px;
  }
`

export const getFinanceCardData = (isTablet?: boolean) => [
  {
    icon: <FinanceVallet />,
    text: 'İhtiyaç Kredisi Hesaplama',
    href: 'https://www.enuygunfinans.com/kredi/ihtiyac/?ref=enuygun-anasayfa-finanswidget',
  },
  {
    icon: <FinanceMoney />,
    text: 'Mevduat Faizi Hesaplama',
    href: 'https://www.enuygunfinans.com/mevduat/?ref=enuygun-anasayfa-finanswidget',
  },
  {
    icon: <FinanceCreditCard />,
    text: 'Kredi Kartı Başvuru',
    href: 'https://www.enuygunfinans.com/kredi-karti/?ref=enuygun-anasayfa-finanswidget',
  },
  {
    icon: (
      <IconOptions $goldPrices $isTablet={isTablet}>
        <FinanceGold />
      </IconOptions>
    ),
    text: 'Altın Fiyatları',
    href: 'https://www.enuygunfinans.com/altin-fiyatlari/?ref=enuygun-anasayfa-finanswidget',
  },
  {
    icon: (
      <IconOptions $currencyCalculation $isTablet={isTablet}>
        <FinanceCurrency />
      </IconOptions>
    ),
    text: 'Döviz Hesaplama',
    href: 'https://www.enuygunfinans.com/doviz-fiyatlari/?ref=enuygun-anasayfa-finanswidget',
  },
  {
    icon: (
      <IconOptions $financeGuide $isTablet={isTablet}>
        <FinanceChart width={32} height={32} />
      </IconOptions>
    ),
    text: 'Finans Rehberi',
    href: 'https://www.enuygunfinans.com/finans-rehberi/?ref=enuygun-anasayfa-finanswidget',
  },
]

// Backward compatibility
export const FinanceCardData = getFinanceCardData()
